import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const ChildrenCompletingEverydayWorksheets = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Children completing everyday worksheets (%)" />
    </Box>
  );
};
